import Button from 'emerald-ui/lib/Button';
import Icon from 'emerald-ui/lib/Icon';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Button, componentName: 'Button' }], 'Button'),
  description: 'The Button represents important calls to action.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Button, Icon },
      whiteBackground: true,
      code: `<Button>
  <Icon name="thumb_up" />
  <span>Default</span>
</Button>`,
    },
  ],
};
